import AuthGuest from "../AuthGuest"
import { API_PUBLIC } from "@/app/contants/url"

const RealizationService = {
  getList: (params: any): AwaitStatusResponse<any> => AuthGuest().get(`${API_PUBLIC}realizations`, { params }),
  getCategories: (params: any): AwaitStatusResponse<any> => AuthGuest().get(`${API_PUBLIC}realizations/categories`, { params }),
  getDetails: (id: string): AwaitStatusResponse<any> => AuthGuest().get(`${API_PUBLIC}realizations/${id}`),
}
export default RealizationService
